import { Search } from "lucide-react";
import React, { useEffect, useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import MemberCard from "../components/MemberCard";

const membersData = [
  // 9th Executive Council Dedicated Members
  {
    id: 1,
    name: "Mr. Sarjo A.K. Jarju ",
    position: "President",
    type: "Executives",
    photo: "https://i.ibb.co/bgvwxdbD/sarjo.jpg",
    email: "akjarju360@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.linkedin.com/in/sarjo-a-k-jarju-23663b30a/",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Gujarat Technological University (GTU)",
    major: "BE Aeronautical Engineering ",
    courseAcronym: "",
    CourseJoiningYear: 2022,
    CourseDuration: "4 years",
  },
  
  {
    id: 2,
    name: "Mr. Modou Lewis",
    position: "Vice President",
    type: "Executives",
    photo: "https://i.ibb.co/d4YcPgK1/lewis.png",
    email: "modoulewis55@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.linkedin.com/in/modou-lewis-106945300?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "DKTE Textile and Engineering Institute ",
    major: "Bachelor of Science in Computer Science and Engineering  ",
    courseAcronym: "",
    CourseJoiningYear: 2022,
    CourseDuration: "4 years",
  },
  
   {
    id: 3,
    name: "Mr. Moses Oumpa Naterse Dobasin",
    position: "Secretary General",
    type: "Executives",
    photo: "https://i.ibb.co/whSJPcm2/moses.png",
    email: "mosesumpanatesedobasin22@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.instagram.com/mr_mmi_international2025?igsh=MXY0dTJlbG93NGViag==",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "KL University ",
    major: "Bachelor of Pharmacy",
    courseAcronym: "",
    CourseJoiningYear: 2022,
    CourseDuration: "4 years",
  },
  
  {
    id: 4,
    name: "Mr. David S. Gibba",
    position: "Asst. Secretary General",
    type: "Executives",
    photo: "https://i.ibb.co/CpGHNKMf/david.jpg",
    email: "dgibba18@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.linkedin.com/in/gibba-david-s-3a044b264?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Andhra University",
    major: "Electronics and Communication Engineering",
    courseAcronym: "",
    CourseJoiningYear: 2023,
    CourseDuration: "4 years",
  },
  
   {
    id: 5,
    name: "Mr. Ebrima YS Cham",
    position: "Finance Minister",
    type: "Executives",
    photo: "https://i.ibb.co/RT8zSVgx/ys.jpg",
    email: "chamebrimays@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.linkedin.com/in/ebrima-y-s-cham-9036a3318?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Delhi University, SRCC",
    major: "Bachelor of Commerce (Honours) ",
    courseAcronym: "",
    CourseJoiningYear: 2023,
    CourseDuration: "3 years",
  },
  
  {
    id: 6,
    name: "Ms. Kadijatou Jallow",
    position: "Deputy Finance Minister",
    type: "Executives",
    photo: "https://i.ibb.co/CKQNcvf/Accademic-Secretary-Kadijatou-jallow.png",
    email: "kadijatou137@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Mahatma Gandhi Mission University",
    major: "Bachelor's of social work  (Honours) ",
    courseAcronym: "",
    CourseJoiningYear: 2023,
    CourseDuration: "3 years",
  },
  
  {
    id: 7,
    name: "Mr. Sainey Bojang",
    position: "Auditor General ",
    type: "Executives",
    photo: "https://i.ibb.co/wZ0XyPB3/basainey.png",
    email: "nyanalachaty1@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.instagram.com/bojang_sainey?igsh=MTZua2xwbzRkcW42MA%3D%3D&utm_source=qr",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "The maharaja sayijirao university of Baroda ",
    major: "M.com accounting and financial management ",
    courseAcronym: "",
    CourseJoiningYear: 2024,
    CourseDuration: "2 years",
  },
  
  {
    id: 8,
    name: "Mrs. Isatou Jatta",
    position: "Information and Communication Minister ",
    type: "Executives",
    photo: "https://i.ibb.co/gZ9S6Vm9/Aisha.jpg",
    email: "satoujatta8@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.facebook.com/share/171Qjii8AR/",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "LNCT University  ",
    major: "Journalism and Mass Communication ",
    courseAcronym: "",
    CourseJoiningYear: 2023,
    CourseDuration: "3 years",
  },

   {
    id: 9,
    name: "Mr. Abdoulie Bawo",
    position: "Deputy Information and Communication Minister ",
    type: "Executives",
    photo: "https://i.ibb.co/CqfCrg7/bawo.png",
    email: "abdouliebawor@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.facebook.com/ablie.bawo.7",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "DKTE Textile & Engineering Institute   ",
    major: "B.Tech Computer Science and Engineering ",
    courseAcronym: "",
    CourseJoiningYear: 2022,
    CourseDuration: "4 years",
   },
  
   {
    id: 10,
    name: "Mr. Mustapha Ceesay",
    position: "Education Minister ",
    type: "Executives",
    photo: "https://i.ibb.co/4RDjz245/mustapha.jpg",
    email: "mc21918139@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.linkedin.com/in/mustapha-ceesay-895198253?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Gujarat University   ",
    major: "Masters in Food Science and Nutrition ",
    courseAcronym: "",
    CourseJoiningYear: 2024,
    CourseDuration: "2 years",
  },
  
   {
    id: 11,
    name: "Ms. Fatou Faye ",
    position: "Deputy Education Minister ",
    type: "Executives",
    photo: "https://i.ibb.co/Xkjt620g/faye.jpg",
    email: "faleemfaye@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.linkedin.com/in/fatou-faye-20a45b372?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Maharaja Sayajirao University of Baroda  ",
    major: "Bachelor in Computer Applications ",
    courseAcronym: "",
    CourseJoiningYear: 2024,
    CourseDuration: "4 years",
  },
  
   {
    id: 12,
    name: "Mrs. Fatoumatta Bittaye ",
    position: "Social & Welfare Minister ",
    type: "Executives",
    photo: "https://i.ibb.co/hzz1325/bittaye.png",
    email: "fatoumatabit943@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.linkedin.com/in/fatoumatta-bittaye-012826265?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Koneru Lakshmaiah ",
    major: "Bachelor in Business Administration ",
    courseAcronym: "",
    CourseJoiningYear: 2023,
    CourseDuration: "3 years",
  },
  
  {
    id: 13,
    name: "Mr. Yaya Jallow ",
    position: "Deputy Social & Welfare Minister ",
    type: "Executives",
    photo: "https://i.ibb.co/CpLCxQ9c/yaya.png",
    email: "yayajallow646@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.instagram.com/babayanky?igsh=MXJteTczMzY3MWVpMw%3D%3D&utm_source=qr",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Gujarat University  ",
    major: "Bachelor in Business Administration & Finance ",
    courseAcronym: "",
    CourseJoiningYear: 2024,
    CourseDuration: "4 years",
  },

   {
    id: 14,
    name: "Ms. Ajaratou Manneh ",
    position: "Logistics Minister ",
    type: "Executives",
    photo: "https://i.ibb.co/h1d5C0bz/ajaratou.png",
    email: "ajaratoumanneh@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.facebook.com/share/1F4bfgVPRC/?mibextid=wwXIfr",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Career College Bhopal ",
    major: "Bachelor in Computer Application ",
    courseAcronym: "",
    CourseJoiningYear: 2023,
    CourseDuration: "3 years",
  },

   {
    id: 15,
    name: "Mr. Ebrima Darboe ",
    position: "Deputy Logistics Minister ",
    type: "Executives",
    photo: "https://i.ibb.co/JwRg2gw7/ebrima.jpg",
    email: "darboebilaal@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.facebook.com/share/14H1wue74JW/",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "I.k Gujral Punjab Technical University (PTU) ",
    major: "Bachelor in Business Administration ",
    courseAcronym: "",
    CourseJoiningYear: 2023,
    CourseDuration: "3 years",
  },

  // 8th Executive Council Dedicated Members
  {
    id: 16,
    name: "Mr. Ebrima Mbowe",
    position: "President",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/Q7VzNjk/Precident-Ebrima-Mbowe.jpg",
    email: "akjarju360@gmail.com",
    tenure: 2025,
    description: "",
    profileLink: "https://www.facebook.com/baye.mbowe.1",
    IGProfileLink: "https://www.instagram.com/mbowevip/",
    LinkedInProfileLink: "http://www.linkedin.com/in/ebrima-mbowe",
    university: "Gujarat Technological University",
    major: "Bachelors Aeronautical Engineering",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },
  
  {
    id: 17,
    name: "Ms. Sainabou Sanyang",
    position: "Vice President",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/C1hR6R5/Sainabou-Sanyang-Social-Welfare-Secretary.png",
    email: "modoulewis55@gmail.com",
    tenure: 2025,
    description: "",
    profileLink:
      "https://www.linkedin.com/in/sainabou-sanyang-8a4050239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    IGProfileLink:
      "https://www.instagram.com/nabou_sanyang?igsh=MWhibHpwYWc2ZWc1OQ%3D%3D&utm_source=qr",
    LinkedInProfileLink:
      "https://www.linkedin.com/in/sainabou-sanyang-8a4050239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    university: "DKTE Textile and Engineering Institute ",
    major: "Computer science and engineering  ",
    courseAcronym: "BUP",
    CourseJoiningYear: 2022,
    CourseDuration: "4 years",
  },
  
  {
    id: 18,
    name: "Mr. Sarjo A.K. Jarju",
    position: "Secretary General",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/sV5hJYJ/Secretary-Sarjo-Jarju.jpg",
    email: "akjarju360@gmail.com",
    tenure: "2024",
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Gujarat Technological University (GTU)",
    major: "BE Aeronautical Eng.",
    courseAcronym: "BE",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },
  
  {
    id: 19,
    name: "Ms. Marie Barry",
    position: "Asst. Secretary General",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/zSd9YZT/Assist-Secretary-Marie-Barry.png",
    email: "mariamajbarry34@gmail.com",
    tenure: "2024",
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Maharaja Sayajirao University of Baroda",
    major: "Zoology",
    courseAcronym: "Zoology",
    CourseJoiningYear: 2023,
    CourseDuration: "3 years",
  },
  
  {
    id: 20,
    name: "Ms. Kadijatou Jallow",
    position: "Academic Secretary",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/CKQNcvf/Accademic-Secretary-Kadijatou-jallow.png",
    email: "kadijatou137@gmail.com",
    tenure: "2024",
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Mahatma Gandhi Mission University",
    major: "Bachelor's of social work Hon.",
    courseAcronym: "BSW",
    CourseJoiningYear: 2023,
    CourseDuration: "2 years",
  },
  
  {
    id: 21,
    name: "Mr. Abdoukarim Ceesay",
    position: "Asst. Academic Secretary",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/LJPDr8M/Ast-Accademic-Sect-Abdou-Karim-Ceesay.png",
    email: "akceesay2002@gmail.com",
    tenure: "2024",
    description: "",
    profileLink: "",
    IGProfileLink:
      "https://www.instagram.com/ak_csay09?igsh=MWlueHd2dmlpaDRnNQ%3D%3D&utm_source=qr",
    LinkedInProfileLink:
      "https://www.linkedin.com/in/abdoukarim-ceesay-5ba3b92a4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    university: "Gujarat Technological University (GTU)",
    major: "Electrical Engineering",
    courseAcronym: "EE",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },
  
  {
    id: 22,
    name: "Ms. Manyima Janneh",
    position: "Social & Welfare Secretary",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/dr7G1qs/Social-Welfare-Manyima-Janneh.png",
    email: "manyimajanneh242@gmail.com",
    tenure: "2024",
    description: "",
    profileLink:
      "https://www.linkedin.com/in/manyima-janneh-aa2a60321?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", // Default value
    IGProfileLink:
      "https://www.instagram.com/maa_janneh1?utm_source=qr&igsh=cDl2Z3UzempxdHI4",
    LinkedInProfileLink:
      "https://www.linkedin.com/in/manyima-janneh-aa2a60321?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    university: "Gujurat University",
    major: "BSc Biochemistry",
    courseAcronym: "BSc",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },
  
  {
    id: 23,
    name: "Mr. Bubacarr Bah",
    position: "Asst. Social & Welfare Sect..",
    type: "Ex-Executives",
    photo:
      "https://i.ibb.co/GvkWSKS/Assistance-Social-Welfare-Bubacarr-Bah.jpg",
    email: "bah.bubacarr3220@gmail.com",
    tenure: "2024",
    description: "",
    profileLink: "https://www.linkedin.com/public-profile/settings",
    IGProfileLink: "",
    LinkedInProfileLink: "https://www.linkedin.com/public-profile/settings",
    university: "Kurukshetra University",
    major: "Bachelor of Business Administration (Hs)",
    courseAcronym: "BBA",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },
  
  {
    id: 24,
    name: "Mr. Ebrima YS Cham",
    position: "Treasurer",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/2YDgX56/Finance-EBRIMA-YS-CHAM.jpg",
    email: "chamebrimays@gmail.com",
    tenure: "2024",
    description: "",
    profileLink:
      "https://www.linkedin.com/in/ebrima-y-s-cham-9036a3318?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    IGProfileLink:
      "https://www.instagram.com/ebrimayscham?igsh=MXFwMW9rZXVsNmRzNA",
    LinkedInProfileLink:
      "https://www.linkedin.com/in/ebrima-y-s-cham-9036a3318?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    university: "Delhi University",
    major: "Bachelor of Commerce",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2023,
    CourseDuration: "2 years",
  },
  
  {
    id: 25,
    name: "Mr. Samba Touray",
    position: "Auditor General",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/4Mhv2dc/Samba-Toray-Auditor.jpg",
    email: "sambatouray02@gmail.com",
    tenure: "2024",
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "samba-touray-4a84372",
    university: "Gujarat University",
    major: "Bachelor of Commerce",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2023,
    CourseDuration: "2 years",
  },
  
  {
    id: 26,
    name: "Mr. Seedy Manneh",
    position: "Public & Relation Officer",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/fNCmLYY/PRO-Seedy-Manneh.png",
    email: "mannehseedy.sm1@gmail.com",
    tenure: "2024",
    description: "",
    profileLink:
      "https://www.linkedin.com/in/seedy-manneh-8150ba31a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app", // Default value
    IGProfileLink:
      "https://www.instagram.com/rio10manneh?igsh=MW14dTl0dHRhMjhheQ==",
    LinkedInProfileLink:
      "https://www.linkedin.com/in/seedy-manneh-8150ba31a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    university: "Golden College of Engineering and Technology",
    major: "Bachelor of Building Construction and Technology",
    courseAcronym: "BBCT",
    CourseJoiningYear: 2023,
    CourseDuration: "2 years",
  },
  
  {
    id: 27,
    name: "Mr. Basiru Mbye",
    position: "Asst. Public & Relation Officer",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/5KMW6MB/Mr-Basiru-Mbye.png",
    email: "mbyebasiru5@gmail.com",
    tenure: "2024",
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Maharaja Sayajirao University of Baroda",
    major: "B.Com (Business Economics)",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },

  {
    id: 28,
    name: "Mr. Muhammed S. Jallow",
    position: "Organiser",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/MDdgP0R/msjallow-organizer.jpg",
    email: "msgambia82@gmail.com",
    tenure: "2024",
    description:
      "Muhammed is a passionate leader with a focus on improving student experiences.",
    // profileLink: "studentProfile",
    profileLink: "https://www.linkedin.com/in/mbsjallow/",
    IGProfileLink: "https://instagram.com/muhammedsjallow",
    LinkedInProfileLink: "https://www.linkedin.com/in/mbsjallow/",
    university: "Andhra University",
    major: "B.Tech Computer Science",
    courseAcronym: "CSE",
    CourseJoiningYear: 2021,
    CourseDuration: "4 years",
  },

  // 7th Executive Council Dedicated Members

  {
    id: 29,
    name: "Mrs. Adama Bah",
    position: "President",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/FV04RP9/Adama-Bah-President.jpg",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Maharaja Sayajirao university of Baroda",
    major: "Bsc. Microbiology (Hons)",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2021,
    CourseDuration: "3 years",
  },

  {
    id: 30,
    name: "Mr. Ebrima Mbowe",
    position: "Vice President",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/Q7VzNjk/Precident-Ebrima-Mbowe.jpg",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: "https://www.facebook.com/baye.mbowe.1",
    IGProfileLink: "https://www.instagram.com/mbowevip/",
    LinkedInProfileLink: "http://www.linkedin.com/in/ebrima-mbowe",
    university: "Delhi University",
    major: "Bachelor of Commerce Honors",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },

  {
    id: 31,
    name: "Mr. Karamo B. Touray",
    position: "Secretary General",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/qx87MJw/Karamo-B-Touray-Secretary-General.jpg",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: " ",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "LNCT University",
    major: "BSc. Physiotherapy",
    courseAcronym: "BP",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },

  {
    id: 32,
    name: "Mr. Omar Jallow",
    position: "Asst. Secretary General",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/zGtdxkQ/Omar-Jallow-Ass-Secretary-General.png",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: " ",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Lovely professional university",
    major: "Bachelor of commerce",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2021,
    CourseDuration: "3 years",
  },
  {
    id: 33,
    name: "Mr. Abdoulie Njie",
    position: "Academic Secretary",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/60mf1fv/Abdoulie-Njie-Academic-Secretary.jpg",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: " ",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Marwadi University",
    major: "BSc Information Technology",
    courseAcronym: "IT",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },

  {
    id: 34,
    name: "Mr. Essa Sowe",
    position: "Asst. Academic Secretary",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/pdSK6DY/Essa-Sowe-Ass-Academic-Secretary.png",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: " ",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Gujurat University",
    major: "BSc Biochemistry",
    courseAcronym: "Biochem",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },

  {
    id: 35,
    name: "Mr. Sheriff Bass",
    position: "Public Relation Secretary",
    type: "Ex-Executives",
    photo:
      "https://i.ibb.co/VSDt2h3/Sheriff-Bass-Public-Relations-Secretary.jpg",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: " ",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Rastriya Raksha University",
    major: "BA International Law & Security Studies",
    courseAcronym: "BA.Law",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },
  
  {
    id: 36,
    name: "Mr. Momodou Lamin Waggeh",
    position: "Asst. Public Relation Secretary",
    type: "Ex-Executives",
    photo:
      "https://i.ibb.co/wNtHpsw/Momodou-Lamin-Waggeh-Ass-Public-Relations-Secretary.jpg",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: " ",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Gujarat University",
    major: "BSc Cybersecurity and Digital Forensics",
    courseAcronym: "CDF",
    CourseJoiningYear: 2022,
    CourseDuration: "3 years",
  },

  {
    id: 37,
    name: "Mr. Sulayman Jallow",
    position: "Treasurer",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/8b9tRkS/Sulayman-Jallow-Treasurer.png",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: " ",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Maharaja Sayajirao University of Baroda",
    major: "Bsc in Economics",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2021,
    CourseDuration: "3 years",
  },
  {
    id: 38,
    name: "Mr. Alieu Ceesay",
    position: "Auditor General",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/Y7YzR1J/Alieu-Ceesay-Auditor-General.png",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: " ",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Panjab University Chandigarh",
    major: "Bsc in Economics",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2021,
    CourseDuration: "3 years",
  },

  {
    id: 39,
    name: "Mss. Sainabou Sanyang",
    position: "Social & Welfare Secretary",
    type: "Ex-Executives",
    photo:
      "https://i.ibb.co/C1hR6R5/Sainabou-Sanyang-Social-Welfare-Secretary.png",
    email: "sainabousanyang9@gmail.com",
    tenure: "2023",
    description: "",
    profileLink:
      "https://www.linkedin.com/in/sainabou-sanyang-8a4050239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    IGProfileLink:
      "https://www.instagram.com/nabou_sanyang?igsh=MWhibHpwYWc2ZWc1OQ%3D%3D&utm_source=qr",
    LinkedInProfileLink:
      "https://www.linkedin.com/in/sainabou-sanyang-8a4050239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    university: "Lovely professional university",
    major: "Bachelor of Urban Planning ",
    courseAcronym: "BUP",
    CourseJoiningYear: 2021,
    CourseDuration: "4 years",
  },
  {
    id: 40,
    name: "Mr. Modou Adama Suwareh",
    position: "Asst. Social and Welfare secretary",
    type: "Ex-Executives",
    photo:
      "https://i.ibb.co/WgzD7NC/Adama-Suwareh-Ass-Social-Welfare-Secretary.png",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: " ",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Panjab University Patiala",
    major: "B. PHARMACY",
    courseAcronym: "BPharm",
    CourseJoiningYear: 2020,
    CourseDuration: "4 years",
  },
  {
    id: 41,
    name: "Mr. Modou Lamin Jeng",
    position: "Organizer",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/HPQmtQx/Modou-Lamin-Jeng-Organizer.jpg",
    email: "baimbowe271@gmail.com",
    tenure: "2023",
    description: "",
    profileLink: " ",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Gujarat Technological University (Svit Vasad 041)",
    major: "BE Aeronautical Engineering",
    courseAcronym: "BEA",
    CourseJoiningYear: 2022,
    CourseDuration: "4 years",
  },

  // 6th Executive council members
  {
    id: 42,
    name: "Mr. Dawda Bojang",
    position: "President",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/Q7VzNjk/Precident-Ebrima-Mbowe.jpg",
    email: "baimbowe271@gmail.com",
    tenure: "2022",
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "University of Delhi",
    major: "B.Tech Electrical Engineering",
    courseAcronym: "B.Tech",
    CourseJoiningYear: 2019,
    CourseDuration: "4 years",
  },

  {
    id: 43,
    name: "Mrs. Ndey Amie Saidy",
    position: "Vice President",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/26ZtM78/Ndey-Amie.jpg",
    email: "amiendey232@gmail.com",
    tenure: "2022",
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Punjab Technical University",
    major: "Bachelor of Pharmacy",
    courseAcronym: "B.Pharm",
    CourseJoiningYear: 2019,
    CourseDuration: "4 years",
  },

  {
    id: 44,
    name: "Mrs. Adama Bah",
    position: "Welfare Secretary",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/FV04RP9/Adama-Bah-President.jpg",
    email: "baimbowe271@gmail.com",
    tenure: "2022",
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Maharaja Sayajirao university of Baroda",
    major: "Bsc. Microbiology (Hons)",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2021,
    CourseDuration: "3 years",
  },

  {
    id: 45,
    name: "Ms. Isatou S. Jallow",
    position: "Ass. Welfare Secretary",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/mhXztx7/Isatou-S-Jallow.jpg",
    email: "isatousj07@gmail.com ",
    tenure: "2022",
    description: "",
    profileLink: "https://www.instagram.com/ayesha.jallow19/",
    IGProfileLink: "https://www.instagram.com/ayesha.jallow19/",
    LinkedInProfileLink: "https://www.instagram.com/ayesha.jallow19/",
    university: "Andhra University",
    major: "Bachelor of Pharmacy",
    courseAcronym: "B.Pharm",
    CourseJoiningYear: 2020,
    CourseDuration: "4 years",
  },

  // Previous Executives council from the 1st to 6th council

  {
    id: 46,
    name: "Mrs. Ndey Amie Saidy",
    position: "Welfare Secretary",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/26ZtM78/Ndey-Amie.jpg",
    email: "amiendey232@gmail.com",
    tenure: "2020",
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Punjab Technical University",
    major: "Bachelor of Pharmacy",
    courseAcronym: "B.Pharm",
    CourseJoiningYear: 2019,
    CourseDuration: "4 years",
  },
  
  {
    id: 47,
    name: "Mr. Tijan S Bah",
    position: "Auditor General",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/zfh03RT/tijan-fabulus.jpg",
    email: "tijansbah20@gmail.com",
    tenure: "2022",
    description: "",
    profileLink: "",
    IGProfileLink: "",
    LinkedInProfileLink: "",
    university: "Maharaja Sayajirao university of Baroda",
    major: "Bachelor of Business Administration",
    courseAcronym: "BBA",
    CourseJoiningYear: 2020,
    CourseDuration: "3 years",
  },

  {
    id: 48,
    name: "Mr. Muhammed M Saidybah ",
    position: "Ass. Academic Secretary",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/DWF6Q9B/mmvisionary-Saidybah.png",
    email: "mmvisionarygm@gmail.com",
    tenure: "2020",
    description: "",
    profileLink: "https://www.facebook.com/muhammed.saidybah.5",
    IGProfileLink: "https://www.facebook.com/muhammed.saidybah.5",
    LinkedInProfileLink: "https://www.facebook.com/muhammed.saidybah.5",
    university: "Punjab Technical University",
    major: "Bachelor of Business Administration",
    courseAcronym: "BBA",
    CourseJoiningYear: 2019,
    CourseDuration: "3 years",
  },

  {
    id: 49,
    name: "Mr. Katim Touray",
    position: "Treasurer",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/ysLm8L3/katim-touray.jpg",
    email: "katimtouray354@gmail.com",
    tenure: "2018",
    description: "",
    profileLink:
      "https://www.linkedin.com/in/katim-touray-3834981aa/overlay/about-this-profile/",
    IGProfileLink: "https://www.facebook.com/katim.touray.777?mibextid=LQQJ4d",
    LinkedInProfileLink:
      "https://www.linkedin.com/in/katim-touray-3834981aa/overlay/about-this-profile/",
    university: "Savitribai Phule Pune University",
    major: "BSc Accounting & Cost & Works Accounting",
    courseAcronym: "BACWA",
    CourseJoiningYear: 2017,
    CourseDuration: "3 years",
  },
  
  {
    id: 50,
    name: "Mr. Alpha Omar Jallow",
    position: "Auditor General",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/XyfbTKk/Alpha-O-Jallow.png",
    email: "jllwlph1@gmail.com",
    tenure: "2020",
    description: "",
    profileLink: "http://linkedin.com/in/alpha-omar-jallow-227070178",
    IGProfileLink: "http://linkedin.com/in/alpha-omar-jallow-227070178",
    LinkedInProfileLink: "http://linkedin.com/in/alpha-omar-jallow-227070178",
    university: "Andhra University",
    major: "B.Tech Civil Engineering",
    courseAcronym: "BCE",
    CourseJoiningYear: 2019,
    CourseDuration: "4 years",
  },

  {
    id: 51,
    name: "Mr. Mamudou Dampha",
    position: "Finance Secretary",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/GCVNWrH/momodu-damphaa.jpg",
    email: "mamudoudampha@gmail.com",
    tenure: "2019",
    description: "",
    profileLink:
      "https://www.linkedin.com/in/mamudou-dampha-msc-international-accounting-ba3a19190/",
    IGProfileLink:
      "https://www.linkedin.com/in/mamudou-dampha-msc-international-accounting-ba3a19190/",
    LinkedInProfileLink:
      "https://www.linkedin.com/in/mamudou-dampha-msc-international-accounting-ba3a19190/",
    university: "University of Mysore",
    major: "Bachelore of Commerce",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2018,
    CourseDuration: "3 years",
  },

  {
    id: 52,
    name: "Mr. Cherno Omar Senghore",
    position: "Public Relations Officer",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/zHpN2Pw/Cherno-Omar-Senghore.png",
    email: "cheboy410@gmail.com",
    tenure: "2019",
    description: "",
    profileLink: "https://www.linkedin.com/in/cherno-omar-senghore-593682170/",
    IGProfileLink:
      "https://www.linkedin.com/in/cherno-omar-senghore-593682170/",
    LinkedInProfileLink:
      "https://www.linkedin.com/in/cherno-omar-senghore-593682170/",
    university: "Parul University",
    major: "B.Tech Computer Science",
    courseAcronym: "CSE",
    CourseJoiningYear: 2016,
    CourseDuration: "4 years",
  },

  {
    id: 53,
    name: "Mr. Basiru Jallow",
    position: "Ass. Secretary General",
    type: "Ex-Executives",
    photo: "https://i.ibb.co/tKfxnd8/Basiru-jallow.jpg",
    email: "basjallow79@gmail.com",
    tenure: "2019",
    description: "",
    profileLink: "https://www.linkedin.com/in/basiruj",
    IGProfileLink: "https://www.linkedin.com/in/basiruj",
    LinkedInProfileLink: "https://www.linkedin.com/in/basiruj",
    university: "Mangalore University",
    major: "Bachelor of Commerce",
    courseAcronym: "B.Com",
    CourseJoiningYear: 2018,
    CourseDuration: "3 years",
  },

 
  // Gambian Embassy Personnel
  {
    id: 54,
    name: "H.E. Mr. Mustapha Jawara",
    position: "High Commissioner",
    type: "Embassy",
    photo: "https://i.ibb.co/pxLsLhR/Mr-Jawarah.jpg",
    email: "gambiahcdelhi@outlook.com",
    tenure: "2020 - Present",
    description:
      "His Excellency, Mr. Mustapha Jawara, holds an Associate degree in Applied Science (AAS) in Information Systems, Network Administration & Support. Mr. Jawara went further to pursue a bachelor's degree in Applied Science (BAS) from Campbell University, RTP Campus, North Carolina, and M.S. in Information systems from Walden University in Minneapolis, Minnesota. Before his appointment in November 2020 as High Commissioner of the Republic of The Gambia to India with concurrent accreditation to Sri Lanka, Bangladesh, and the Maldives, Mr. Jawara worked at The Friday Institute For Educational Innovation, North Carolina University as a Technology Analyst. He is active in numerous organizations as a board member.",
    profileLink: "studentProfile",
    IGProfileLink: "https://instagram.com/mustaphajawara",
    LinkedInProfileLink: "linkedin.com/in/mustapha-jawara-8b632a36",
    expertise: "Network Administration & Support",
    courseAcronym: "NAS",
  },
];

const calculateYearOfStudy = (member) => {
  const currentYear = new Date().getFullYear();

  if (!member.CourseJoiningYear || member.year === "Graduated") {
    return member.year;
  }

  const yearsCompleted = currentYear - member.CourseJoiningYear;
  const courseDuration = parseInt(member.CourseDuration, 10);

  if (yearsCompleted >= courseDuration) {
    return "Graduated";
  }

  if (yearsCompleted === 0) {
    return "1st year";
  } else if (yearsCompleted === 1) {
    return "2nd year";
  } else if (yearsCompleted === 2) {
    return "3rd year";
  } else if (yearsCompleted === 2) {
    return "4th year";
  }

  return `${yearsCompleted + 1}th year`;
};

const Members = () => {
  const [expandedId, setExpandedId] = useState(null);
  const [filter, setFilter] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [members, setMembers] = useState(membersData);
  const [yearFilter, setYearFilter] = useState("All");

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  useEffect(() => {
    const updatedMembers = membersData.map((member) => ({
      ...member,
      year: calculateYearOfStudy(member),
    }));
    setMembers(updatedMembers);
  }, []);

  const filteredMembers = members.filter((member) => {
    const matchesFilter = filter === "All" || member.type === filter;
    const matchesSearch = member.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    const matchesYear =
      member.type !== "Ex-Executives" ||
      yearFilter === "All" ||
      member.tenure === yearFilter;

    return matchesFilter && matchesSearch && matchesYear;
  });

  const embassy = filteredMembers.filter((member) => member.type === "Embassy");
  const executives = filteredMembers.filter(
    (member) => member.type === "Executives"
  );
  const exExecutives = filteredMembers.filter(
    (member) => member.type === "Ex-Executives"
  );

  const sortedExExecutives = exExecutives.sort(
    (a, b) => parseInt(b.tenure) - parseInt(a.tenure)
  );

  const mostRecentYear =
    sortedExExecutives.length > 0 ? sortedExExecutives[0].tenure : null;

  const displayedExExecutives =
    yearFilter === "All"
      ? sortedExExecutives
      : sortedExExecutives.filter((member) => member.tenure === yearFilter);

  const years = [...new Set(exExecutives.map((member) => member.tenure))].sort(
    (a, b) => b - a
  );

  return (
    <div className="bg-gray-100">
      <div
        className="relative bg-cover bg-center py-44"
        style={{
          backgroundImage:
            "url('https://i.ibb.co/4jtwMFF/manav-group-pics.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-black opacity-60"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl lg:text-7xl font-bold text-white mb-2 relative z-10">
            Our Community
          </h1>
          <p className="text-xl text-gray-300">
            Meet Our Gam-Ind Executives and Embassy Personnel
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row justify-between items-center mb-8">
          <div className="flex flex-wrap justify-center sm:justify-start space-x-2 mb-4 sm:mb-0">
            {["All", "Executives", "Ex-Executives", "Embassy"].map((type) => (
              <button
                key={type}
                onClick={() => {
                  setFilter(type);
                  if (type === "Ex-Executives") {
                    setYearFilter(mostRecentYear || "All");
                  } else {
                    setYearFilter("All");
                  }
                }}
                className={`px-4 py-2 rounded-full mb-2 ${
                  filter === type
                    ? "bg-blue-500 text-white"
                    : "bg-gray-200 text-gray-800 hover:bg-gray-300"
                }`}
              >
                {type}
              </button>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-2">
            {filter === "Ex-Executives" && (
              <div className="flex items-center">
                {/* Calendar Icon in a button */}
                <button
                  className="border border-gray-300 rounded-l-md flex items-center justify-center bg-white"
                  style={{ height: "40px", width: "40px" }} // Fixed height for both button and select
                >
                  <FaCalendarAlt className="text-gray-500 text-xl" />
                </button>

                {/* Dropdown for year selection */}
                <select
                  value={yearFilter}
                  onChange={(e) => setYearFilter(e.target.value)}
                  className="border border-gray-300 rounded-r-md bg-white sm:border-l-0 w-auto"
                  style={{
                    height: "40px", // Match height to button
                    width: "120px", // Width adjusted based on the content
                    padding: "0 12px",
                  }}
                >
                  <option value="All">All Years</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="relative w-full sm:w-auto">
              <input
                type="text"
                placeholder="Search members..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full sm:w-64 pl-10 pr-4 py-2 border-2 rounded-full"
              />
              <Search
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
                size={20}
              />
            </div>
          </div>
        </div>

        {executives.length > 0 && (
          <div>
            <h2 className="text-3xl font-bold mb-6">Current Executives Council</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {executives.map((member) => (
                <MemberCard key={member.id} member={member} />
              ))}
            </div>
          </div>
        )}

        {filter === "Ex-Executives" && displayedExExecutives.length > 0 && (
          <div className="mt-12">
            <h2 className="text-3xl font-bold mb-6">
              {yearFilter === "All"
                ? "All Ex-Executives"
                : `Ex-Executives (${yearFilter})`}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {displayedExExecutives.map((member) => (
                <MemberCard key={member.id} member={member} />
              ))}
            </div>
          </div>
        )}
        {/* EMBASSY Section */}
        {embassy.length > 0 && (
          <div className="mt-8 sm:mt-12 max-w-7xl mx-auto">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6">Our Embassy</h2>
            <div className="space-y-6 sm:space-y-8">
              {embassy.map((member) => (
                <div
                  key={member.id}
                  className="bg-white rounded-lg shadow-sm overflow-hidden flex flex-col sm:flex-row"
                >
                  {/* Updated Image Container and Fitting */}
                  <div className="w-full sm:w-1/3 p-2 sm:p-3">
                    <img
                      src={member.photo}
                      alt={member.name}
                      className="w-full h-auto sm:h-64 md:h-80 object-top border-2 border-gray-200 rounded-lg"
                    />
                  </div>

                  {/* Reduced padding between image and details */}
                  <div className="p-2 sm:p-3 sm:w-2/3 flex flex-col justify-between">
                    <div>
                      <h2 className="text-lg sm:text-xl md:text-2xl font-semibold sm:mb-2">
                        <span className="text-black">{member.name}</span>
                        <span className="text-gray-500">
                          {" "}
                          - {member.position}
                        </span>
                      </h2>
                      <p className="text-gray-600 text-sm sm:text-base sm:mb-2">
                        {member.email}
                      </p>
                      <p className="text-gray-500 text-sm sm:text-base sm:mb-2">
                        {member.tenure}
                      </p>
                      <p className="text-gray-500 text-sm sm:text-base mb-1">
                        <span className="font-semibold">Expertise:</span>{" "}
                        {member.expertise}
                      </p>
                      <div
                        className="text-gray-700 text-sm sm:text-base cursor-pointer"
                        onClick={() => toggleExpand(member.id)}
                      >
                        {expandedId === member.id ? (
                          <p>{member.description}</p>
                        ) : (
                          <p className="line-clamp-3 sm:line-clamp-4">
                            {member.description}
                            {member.description.length > 200 && (
                              <span className="text-blue-500">...</span>
                            )}
                          </p>
                        )}
                        {member.description.length > 200 && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleExpand(member.id);
                            }}
                            className="text-blue-500 hover:text-blue-700 transition duration-300 text-sm"
                          >
                            {expandedId === member.id
                              ? "Read less"
                              : "Read more"}
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="mt-2 sm:mt-4">
                      <button
                        onClick={() =>
                          window.open(member.profileLink, "_blank")
                        }
                        className="w-full sm:w-auto bg-blue-500 text-white px-3 sm:px-4 py-2 rounded hover:bg-blue-600 transition duration-300 text-sm sm:text-base"
                      >
                        View Profile
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {filteredMembers.length === 0 && (
          <p className="text-center text-gray-500 mt-8">
            No members found matching your search criteria.
          </p>
        )}
      </div>
    </div>
  );
};

export default Members;
